var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1",staticStyle:{"padding-bottom":"0px"}},[_c('GameHeader'),_c('router-view'),_c('GameFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }